/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../../ColorsProvider";
import Button from "../../Button";
import RichLabel from "../../RichLabel";
import Slider from "../../Slider";
import Theme from "../../Theme";
import prefixStyles from "../../utils/prefixStyles";

const styles = prefixStyles({
  wrapper: {
    display: "flex",
    width: "100%",
  },
  button: {
    fontSize: "0.75em",
    alignSelf: "center",
    flex: "0 0 auto",
  },
  slider: {
    flex: "1 1 33%",
    alignSelf: "center",
    paddingTop: 0,
  },
});

type ButtonField = {
  label: string,
  icon?: ?React.Element<any>,
};

type Props = {
  display?: ?{
    postfix: string,
  },
  hasOffState: boolean,
  label?: ?string,
  value?: ?number,
  min: number,
  max: number,
  step: number,
  stepValues?: ?{ [rawValue: number]: string },
  minButton?: ?ButtonField,
  maxButton?: ?ButtonField,
  onChange?: ?(newValue: number) => void,
  colors: ColorSet,
};

type State = {
  value: number,
};

class SliderField extends React.Component<Props, State> {
  static defaultProps = {
    hasOffState: true,
    step: 1,
  };

  state = {
    // A factory reset thermostat doesn't always provide a value, so use the min.
    value: this.props.value != null ? this.props.value : this.props.min,
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.state.value) {
      this.setState({
        value: nextProps.value != null ? nextProps.value : nextProps.min,
      });
    }
  }

  _formatSliderValue = (value: number) => {
    const { stepValues, display } = this.props;
    let displayValue = String(value);
    if (stepValues && stepValues[value] != null) {
      displayValue = stepValues[value];
    }
    if (display) {
      displayValue = `${displayValue}${display.postfix}`;
    }
    return displayValue;
  };

  handleChange = (value: number) => {
    if (value === this.state.value) {
      return;
    }

    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  createButton(subField: ButtonField, clickValue: number, style?: Object) {
    return (
      <Button
        onTap={() => {
          this.setState({ value: clickValue });
          if (this.props.onChange) {
            this.props.onChange(clickValue);
          }
        }}
        style={{
          ...styles.button,
          ...style,
        }}
      >
        <RichLabel icon={subField.icon} label={subField.label} />
      </Button>
    );
  }

  render() {
    const {
      hasOffState,
      label,
      min,
      max,
      step,
      minButton,
      maxButton,
      colors,
    } = this.props;

    const { value } = this.state;

    return (
      <div
        data-component-name="SliderField"
        style={{
          color: colors.TEXT,
          boxSizing: "border-box",
          padding: Theme.Padding.CONTENT,
        }}
      >
        {label ? <span data-component-section="label">{label}</span> : null}
        <div
          style={{
            ...styles.wrapper,
            marginTop: label ? 12 : 30, // spacing between label or extra for tooltip w/o label
          }}
        >
          {minButton ? this.createButton(minButton, min) : null}
          <Slider
            hasOffState={hasOffState}
            style={{
              ...styles.slider,
              marginLeft: minButton ? Theme.Padding.CONTENT : "",
            }}
            min={min}
            max={max}
            step={step}
            value={value}
            showValueAboveHandle
            formatValue={this._formatSliderValue}
            onChange={this.handleChange}
          />
          {maxButton
            ? this.createButton(maxButton, max, {
                marginLeft: Theme.Padding.CONTENT,
              })
            : null}
        </div>
      </div>
    );
  }
}

export default withColorsProvider(SliderField);



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/SliderField.jsx